import { Axios } from 'utils/AxiosConfig'

export const getListMessage = async (payload) => {
  const { data: response } = await Axios.get(`member/contact-request`, payload)
  return response
}

export const postAcceptRequest = async (payload, id) => {
  const { data: response } = await Axios.put(`member/contact-request/${id}`, payload)
  return response
}

export const postContactRequest = async (payload) => {
  const { data: response } = await Axios.post(`member/contact-request`, payload)
  return response
}

export const getListChat = async () => {
  const { data: response } = await Axios.get(`member/message`)
  return response
}

export const cancelRequestContact = async (id) => {
  const { data: response } = await Axios.put(`member/contact-request/cancel/${id}`)
  return response
}